import React from "react";
import Layout from "../../components/layout";
import { useState, useEffect, useCallback } from "react";   
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { showLoading, hideLoading } from "../../redux/alertsSlice"; 
import DoctorForm from "../../components/DoctorForm";
import {useNavigate, useParams} from "react-router-dom";
import { toast } from "react-hot-toast";
import moment from "moment";
import { Card } from "antd";


function Profile() {

  const {user} = useSelector((state) => state.user); 
  const params = useParams();
  const [ doctor, setDoctor] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();




  const onFinish = async (values) => {
    try {
      //post request to register user
      dispatch(showLoading());
      const response = await axios.post(
        "/api/doctor/update-doctor-info-by-user-id",
        { ...values, userId: user._id,
          appointmentTime: [
            moment(values.appointmentTime[0]).format("HH:mm"), 
            moment(values.appointmentTime[1]).format("HH:mm")
          
          ],
         
       },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        //toast message
        toast.success(response.data.message);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  const getDoctorData = useCallback(async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/doctor/get-doctor-info-by-user-id",
        {
          userId: params.userId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        const doctorData = response.data.data;
        setDoctor({
          ...doctorData,
          appointmentDate: moment(doctorData.appointmentDate, "YYYY-MM-DD"),
        });
      }
    } catch (error) {
      dispatch(hideLoading());
      // handle error (optional)
    }
  }, [dispatch, params.userId, setDoctor]);

  useEffect(() => {
    getDoctorData();
  }, [getDoctorData]);
return (
  <Layout>


    {doctor && (
      <Card title="Update Profile" bordered={false} className="mb-4" style={{ maxWidth: 800, margin: "0 auto" }}>
        <DoctorForm onFinish={onFinish} initivalValues={doctor} />
      </Card>
    )}
  </Layout>
);

}

export default Profile;   